<template>
  <div>
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('contracttype_edit')" >
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-gavel</v-icon>{{ item['name'] }}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-contracttype-show">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('global.name') }}</strong></td>
              <td>
                                    {{ item['name'] }}
              </td>
              <td><strong>{{ $t('contract.duration') }}</strong></td>
              <td>
                                    {{ item['duration'] }}
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('contract.guarantee') }}</strong></td>
              <td>
                <span v-if="item.guarantee" class="mr-2"><v-icon color="green">mdi-check-circle</v-icon></span>
                <span v-else class="mr-2"><v-icon color="red">mdi-close-circle</v-icon></span>
              </td>
              <td><strong>{{ $t('contract.maintenance') }}</strong></td>
              <td>
                <span v-if="item.maintenance" class="mr-2"><v-icon color="green">mdi-check-circle</v-icon></span>
                <span v-else class="mr-2"><v-icon color="red">mdi-close-circle</v-icon></span>
              </td>

            </tr>
            <tr>
              <td><strong>{{ $t('contract.description') }}</strong></td>
              <td colspan="3">
                  {{ item['description'] }}
              </td>

            </tr>


          </tbody>
        </template>
      </v-simple-table>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';


const servicePrefix = 'Contracttype';

export default {
  name: 'ContracttypeShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar,
  },
  data() {
    return {

    };
  },
  mixins: [ShowMixin,AccessMixin],
  computed: {
    ...mapFields('contracttype', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('contracttype', ['find']),

  },
  methods: {
    ...mapActions('contracttype', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    }),

  }
};
</script>
